"use client";

import { c as _c } from "react/compiler-runtime";
import CenteredArea from "@/components/layout/centered-area";
import { Button } from "@/components/ui/button";
import { getComments } from "@/queries-alt/with-use-server";
import { TContentType } from "@/types/types";
import { useInfiniteQuery } from "@tanstack/react-query";
import { Loader } from "lucide-react";
import CommentItem from "./comment-item";
import { useAuth } from "@clerk/nextjs";
type CommentsListProps = {
  contentType: TContentType;
  contentId: string;
};
export default function CommentsList(t0) {
  const $ = _c(25);
  const {
    contentType,
    contentId
  } = t0;
  const {
    userId
  } = useAuth();
  const t1 = `get-comments:${contentType}:${contentId}`;
  let t2;
  if ($[0] !== t1) {
    t2 = [t1];
    $[0] = t1;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== contentId || $[3] !== contentType || $[4] !== userId) {
    t3 = async t4 => {
      const {
        pageParam
      } = t4;
      return await getComments({
        contentType,
        contentId,
        page: pageParam,
        userId
      });
    };
    $[2] = contentId;
    $[3] = contentType;
    $[4] = userId;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== t2 || $[7] !== t3) {
    t4 = {
      queryKey: t2,
      queryFn: t3,
      initialPageParam: 1,
      getNextPageParam: _temp
    };
    $[6] = t2;
    $[7] = t3;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  const {
    data,
    status,
    fetchNextPage,
    isFetchingNextPage,
    hasNextPage
  } = useInfiniteQuery(t4);
  if (status === "pending") {
    let t5;
    if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
      t5 = <CenteredArea><Loader className="animate-spin" /></CenteredArea>;
      $[9] = t5;
    } else {
      t5 = $[9];
    }
    return t5;
  }
  let t5;
  let t6;
  if ($[10] !== contentId || $[11] !== contentType || $[12] !== data?.pages) {
    const comments = data?.pages.flatMap(_temp2) || [];
    t5 = "flex flex-col gap-2";
    t6 = comments.length > 0 ? comments.map(comment => <CommentItem key={comment.id} contentType={contentType} contentId={contentId} comment={comment} />) : <CenteredArea className="border text-sm">No comments yet.</CenteredArea>;
    $[10] = contentId;
    $[11] = contentType;
    $[12] = data?.pages;
    $[13] = t5;
    $[14] = t6;
  } else {
    t5 = $[13];
    t6 = $[14];
  }
  let t7;
  if ($[15] !== t5 || $[16] !== t6) {
    t7 = <ul className={t5}>{t6}</ul>;
    $[15] = t5;
    $[16] = t6;
    $[17] = t7;
  } else {
    t7 = $[17];
  }
  let t8;
  if ($[18] !== fetchNextPage || $[19] !== hasNextPage || $[20] !== isFetchingNextPage) {
    t8 = hasNextPage && <Button variant="outline" disabled={isFetchingNextPage} onClick={() => fetchNextPage()} className="mx-auto mt-4 w-fit shrink-0">{isFetchingNextPage ? "Loading more..." : "Load more"}</Button>;
    $[18] = fetchNextPage;
    $[19] = hasNextPage;
    $[20] = isFetchingNextPage;
    $[21] = t8;
  } else {
    t8 = $[21];
  }
  let t9;
  if ($[22] !== t7 || $[23] !== t8) {
    t9 = <>{t7}{t8}</>;
    $[22] = t7;
    $[23] = t8;
    $[24] = t9;
  } else {
    t9 = $[24];
  }
  return t9;
}
function _temp2(page) {
  return page.comments;
}
function _temp(lastPage) {
  return lastPage.pagination.hasMore ? lastPage.pagination.page + 1 : undefined;
}